import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "../lib/utils"
import { tooltipSurface } from "../styles/recipes.js"
import { PortalContainerContext } from './portal-container.jsx';

function TooltipProvider({
  delayDuration = 0,
  ...props
}) {
  return (<TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />);
}

function Tooltip({
  ...props
}) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

const TooltipTrigger = React.forwardRef(({ ...props }, ref) => (
  <TooltipPrimitive.Trigger ref={ref} data-slot="tooltip-trigger" {...props} />
));
TooltipTrigger.displayName = TooltipPrimitive.Trigger.displayName;

const TooltipContent = React.forwardRef(({
  className,
  sideOffset = 0,
  children,
  container,
  ...props
}, ref) => {
  const portalContainer = React.useContext(PortalContainerContext)
  return (
    <TooltipPrimitive.Portal container={container === undefined ? portalContainer : container}>
      <TooltipPrimitive.Content
        ref={ref}
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          `animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-1.5 data-[side=left]:slide-in-from-right-1.5 data-[side=right]:slide-in-from-left-1.5 data-[side=top]:slide-in-from-bottom-1.5 z-[var(--ds-layer-transient)] w-fit origin-(--radix-tooltip-content-transform-origin) ${tooltipSurface} px-[var(--ds-space-3)] py-[var(--ds-space-1-5)] text-xs font-medium text-balance`,
          className
        )}
        {...props}>
        {children}
        <TooltipPrimitive.Arrow
          className="bg-popover fill-popover stroke-border z-[var(--ds-layer-transient)] size-[var(--ds-icon-size-indicator)] translate-y-[calc(-50%_-_var(--ds-space-half))] rotate-45 rounded-[var(--ds-radius-control-compact)]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
